import { t } from '@sm/intl';
import COPY from '~app/pages/Pricing/copy';

export type RouteObject = {
  [key: string]: Route;
};

export type Route = {
  path: string;
  title: string;
  queryString: {
    ut_source: string;
  };
  packageType: string;
};

const ROUTE_CONFIG: RouteObject = {
  teams: {
    path: '/pricing/teams',
    title: t(COPY.TEAM_PLANS),
    queryString: {
      ut_source: 'pricing-teams-summary',
    },
    packageType: 'teams',
  },
  individual: {
    path: '/pricing/individual',
    title: t(COPY.INDIVIDUAL_PLANS),
    queryString: {
      ut_source: 'pricing-indv-summary',
    },
    packageType: 'individual',
  },
  enterprise: {
    path: '/pricing/enterprise',
    title: t(COPY.ENTERPRISE),
    queryString: {
      ut_source: 'pricing-ent-summary',
    },
    packageType: 'enterprise',
  },
};

export default ROUTE_CONFIG;
